import { useEffect } from "react"
import { Outlet, useLocation } from "react-router-dom"
import { Nav } from "./Nav"
import { useShellStore } from "./shell.store"
import { Toaster } from "@/components/ui/toaster"
import { GlobalErrorRenderer } from "@/features/layout/GlobalErrorRenderer"
import { ConfirmDialog } from "@/components/ConfirmDialog"
import { useThreadContext } from "@/providers/ThreadProvider"
import { CopilotKitProvider } from "@/providers/CopilotKitProvider"
import { GenerationTracker } from "@/features/oio/components/GenerationTracker"
import { DraftingRoute } from "@/features/drafting/DraftingRoute"
import { ErrorBoundary } from "@/components/ErrorBoundary"
import { PaywallModal } from "@/components/PaywallModal"
import { SimulatorModal } from "@/features/simulators/SimulatorModal"

export function AppShell() {
  const { navMode, simulatorService, closeSimulator } = useShellStore()
  const { activeThread, threadsInitialized } = useThreadContext()
  const location = useLocation()
  const isDrafting = location.pathname.startsWith("/drafting")

  useEffect(() => {
    document.documentElement.setAttribute("data-nav", navMode)
  }, [navMode])

  return (
    <div className="app">
      <Nav />
      <div className="work">
        <GlobalErrorRenderer />
        {/* CopilotKit is mounted at the shell level (keyed on the active case),
            and the Drafting workspace is kept mounted across navigation (hidden
            when off /drafting). Together this keeps a running OIO generation
            streaming while the officer moves between tabs — the session and its
            stream reader are no longer torn down per route. */}
        {threadsInitialized ? (
          <ErrorBoundary key={activeThread?.id ?? "no-case"}>
            <CopilotKitProvider>
              <GenerationTracker />
              <div className="route-pane" style={{ display: isDrafting ? "block" : "none" }}>
                <DraftingRoute />
              </div>
              <div className="route-pane" style={{ display: isDrafting ? "none" : "block" }}>
                <Outlet />
              </div>
            </CopilotKitProvider>
          </ErrorBoundary>
        ) : (
          <div className="empty" style={{ height: "calc(100vh - 64px)" }}>
            <span className="spinner" />
            <p style={{ marginTop: 12 }}>Loading…</p>
          </div>
        )}
      </div>
      {simulatorService && <SimulatorModal service={simulatorService} onClose={closeSimulator} />}
      <ConfirmDialog />
      <PaywallModal />
      <Toaster />
    </div>
  )
}
